<script lang="ts">
	import 'virtual:windi.css';
	import '$lib/assets/styles/main.scss';
	import { onMount } from 'svelte';
	import type { LayoutData } from './$types';
	import AppView from '$views/app/AppView.svelte';
	import { setLocale } from '$i18n';
	import { logger } from '@shared/utils';

	export let data: LayoutData;
	const { currentRoutePath, device, locale, userSession } = data;

	setLocale(locale);

	let webManifest = '';
	onMount(async () => {
		if (
			import.meta.env['PUBLIC_PWA_DISABLED'] === '1' ||
			window.top !== window.self
		) {
			logger.log('PWA Disabled');
			return;
		}
		const { pwaInfo, registerSW } = await import('$utils/pwa');

		logger.log('PWA Info', pwaInfo);
		if (!pwaInfo) {
			return;
		}
		webManifest = pwaInfo.webManifest.linkTag;

		// Auto update pwa https://vite-pwa-org.netlify.app/frameworks/sveltekit.html#auto-update
		registerSW({
			immediate: true,
			onRegistered(serviceWorkerRegistration) {
				logger.log('SW Registered', serviceWorkerRegistration);
			},
			onRegisterError(error) {
				logger.error('SW registration error', error);
			},
		});
	});
</script>

<svelte:head>
	{@html webManifest}
</svelte:head>

<AppView
	userSession={userSession}
	device={device}
	currentRoutePath={currentRoutePath}>
	<slot />
</AppView>
